import * as React from 'react';
import { FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField, Box, Checkbox, Button, Autocomplete, Backdrop, CircularProgress, Typography } from "@mui/material";
import { useState } from "react"
import SaveIcon from '@mui/icons-material/Save';
import { useTheme } from '@mui/material/styles';
import { useEffect } from "react";
import { buttonStyle, iconStyle, cardStyle } from "../../styles/sharedStyles.js"
import { fetchAPI } from "../../utils/ApiService.js"
import { forwardRef } from 'react';
import { useImperativeHandle } from 'react';
import { CustomizedSnackbar } from '../../utils/CustomizedSnackbar.jsx';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};


export const MultiDropDown = forwardRef(({ data, problemName }, ref) => {

    const [targetVariables, setTargetVariables] = useState([]);
    const [selectedInput, setSelectedInput] = useState([]);
    const [boundaryVariables, setBoundaryVariables] = useState([]);
    const [selectedBoundary, setSelectedBoundary] = useState("");
    const [outputVariables, setOutputVariables] = useState([]);
    const [selectedOutput, setSelectedOutput] = useState([]);
    const [saveButtonDisalbe, setSaveButtonDisalbe] = useState(true);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [severityType, setSeverityType] = useState("success");
    const [loadopen, setLoadpen] = useState(false);
    const [inputConstraints, setInputConstraints] = useState("");
    const [outputConstraints, setOutputConstraints] = useState("");


    React.useImperativeHandle(ref, () => ({
        grandchildFunction() {
            console.log("grandchild component...")
            setTargetVariables([]);
            setSelectedInput([]);
            setSelectedBoundary("");
            setSelectedOutput([]);
            setInputConstraints("");
            setOutputConstraints("");

        }
    }));


    useEffect(() => {
        if (data) { setTargetVariables(data) }
    }, [data]);

    useEffect(() => {
        if (!targetVariables.length) return;

        const availableBoundaries = targetVariables.filter(
            variable => !selectedInput.includes(variable)
        );

        setBoundaryVariables(availableBoundaries);
    }, [selectedInput, targetVariables]);


    // Update outputVariables when selectedInput or selectedBoundary changes
    useEffect(() => {
        if (!targetVariables.length) return;

        const remaining = targetVariables.filter(
            item => !selectedInput.includes(item) && item !== selectedBoundary
        );

        setOutputVariables(remaining);
        isSaveAvailable();
    }, [selectedInput, selectedBoundary, targetVariables]);


    // Clean up selectedOutput if any values are no longer valid
    useEffect(() => {
        setSelectedOutput(prevSelected =>
            prevSelected.filter(value => outputVariables.includes(value))
        );
    }, [outputVariables]);


    // Reset selectedBoundary if it becomes invalid
    useEffect(() => {
        if (selectedBoundary && !boundaryVariables.includes(selectedBoundary)) {
            setSelectedBoundary('');
        }
    }, [boundaryVariables, selectedBoundary]);

    useEffect(() => {
        isSaveAvailable();
    }, [selectedOutput])


    const handleInputChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedInput(
            typeof value === 'string' ? value.split(',') : value,
        )

    }

    const handleBoundaryChange = (event) => {
        setSelectedBoundary(event.target.value);

    }

    const handleOutputChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedOutput(
            typeof value === 'string' ? value.split(',') : value,
        )

    }

    const saveProblemFormulation = async () => {
        setSnackbarOpen(false);
        setLoadpen(true)
        const payload = {
            "problem_name": problemName,
            "selected_inputs": selectedInput,
            "selected_boundary": selectedBoundary,
            "selected_output": selectedOutput,
            "input_constraints": inputConstraints,
            "output_constraints": outputConstraints,
        }
        try {
            const response = await fetchAPI.post("/save_problem", payload, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                }
            });
            if (response.status === 202 || response.status === 200) {

                const checkUploadStatus = async () => {

                    try {
                        const statusResponse = await fetchAPI.post("/upload_save_stats", { problemName }, {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                            }
                        });

                        if (statusResponse.status === 200) {
                            if (statusResponse?.data?.data?.error) {
                                console.log(statusResponse.data.data.message)
                                setSnackbarMsg(statusResponse.data.data.message)
                                setSeverityType("warning")


                            } else {

                                setSnackbarMsg("Selected data saved successfully")
                                setSeverityType("success")

                            }
                            setLoadpen(false)
                            setSnackbarOpen(true)

                        }
                        else {
                            console.log('Waiting for upload status to complete...');
                            setTimeout(checkUploadStatus, 5000);
                        }

                    } catch (error) {
                        const errorMessage = error.response.data.message || 'Error while saving the selected data';
                        console.error(errorMessage);
                        setLoadpen(false)
                        setSnackbarMsg(errorMessage)
                        setSeverityType("error")
                        setSnackbarOpen(true)

                    }

                };
                checkUploadStatus();

            } else {
                const msg = 'Error while saving the selected data'
                setLoadpen(false)
                setSnackbarMsg(msg)
                setSnackbarOpen(true)
                throw new Error(msg);
                // setTimeout(checkUploadStatus, 2000);
            }


        } catch (error) {

            const errorMessage = error.response?.data?.message || 'Error while saving the selected data';
            setSnackbarMsg(errorMessage);
            setSeverityType("error");
            setSnackbarOpen(true);
            setLoadpen(false)

        }
        

    }

    const isSaveAvailable = () => {
        if (selectedInput.length > 0 && selectedBoundary != "" && selectedOutput.length > 0) {
            setSaveButtonDisalbe(false)
        } else {
            setSaveButtonDisalbe(true)
        }

    }

    const handleInputConstraints = (event) => {
        setInputConstraints(event.target.value)

    }

    const handleOutputConstraints = (event) => {
        setOutputConstraints(event.target.value)

    }




    return (
        <>

            <Box
                display="flex"
                flexWrap="wrap"
                gap={3}
                justifyContent="space-between"
                sx={{ width: "100%", paddingTop: "20px", paddingLeft: "10px" }}
            >

                <Autocomplete
                    multiple
                    options={targetVariables}
                    value={selectedInput}
                    onChange={(event, newValue) => setSelectedInput(newValue)}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option}
                    renderOption={(props, option, { selected }) => (
                        <li {...props}>
                            <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                            />
                            {option}
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Select geometry inputs"
                            placeholder="Select options"
                        />
                    )}
                    sx={{ flex: '1 1 45%', minWidth: 250 }}
                />

                <FormControl sx={{ flex: '1 1 45%', minWidth: 250 }}>
                    <InputLabel id="bounder-checkbox-label">Select boundary condition input</InputLabel>
                    <Select
                        labelId="bounder-checkbox-label"
                        id="bounder-checkbox"
                        multiple={false}
                        value={selectedBoundary}
                        onChange={handleBoundaryChange}
                        input={<OutlinedInput label="Select boundary condition input" />}

                        MenuProps={MenuProps} >
                        {boundaryVariables?.map((item) => (
                            <MenuItem key={item} value={item} >
                                <ListItemText primary={item} />
                            </MenuItem>
                        ))}

                    </Select>
                </FormControl>



                <Autocomplete
                    multiple
                    options={outputVariables}
                    value={selectedOutput}
                    onChange={(event, newValue) => setSelectedOutput(newValue)}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option}
                    renderOption={(props, option, { selected }) => (
                        <li {...props}>
                            <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                            />
                            {option}
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Select output variable"
                            placeholder="Select options"
                        />
                    )}
                    sx={{ flex: '1 1 95%', minWidth: 250 }}
                />
                
                    <Typography component="h1" sx={{ flex: '1 1 100%', minWidth: 250 }}>Define rules for valid inputs and outputs (i.e. input1 {'>'}= 2*input2)

                    </Typography>

                

                

                <FormControl sx={{ flex: '1 1 45%', minWidth: 250 }}>
                    <TextField

                        id="outlined-basic-input"
                        label="Enter input constraints (press shift + enter, to go to a new line.)"
                        variant="outlined"
                        multiline
                        onChange={handleInputConstraints}
                        value={inputConstraints}
                    />

                </FormControl>
                <FormControl sx={{ flex: '1 1 45%', minWidth: 250 }}>
                    <TextField

                        id="outlined-basic-output"
                        label="Enter output constraints (press shift + enter, to go to a new line.)"
                        variant="outlined"
                        multiline
                        onChange={handleOutputConstraints}
                        value={outputConstraints}
                    />

                </FormControl>


                <Button disabled={saveButtonDisalbe} fullWidth variant="contained" sx={[buttonStyle, { flex: '1 1 30%', minWidth: 150 }]} onClick={saveProblemFormulation}> <span><SaveIcon sx={iconStyle} /></span><span>Save</span></Button>
                
            </Box>

            <CustomizedSnackbar action={snackbarOpen} message={snackbarMsg} severityType={severityType} />

            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loadopen}
            >
                <CircularProgress size="4rem" />
            </Backdrop>


        </>
    )
})